/**
 * ActivationHero — left-panel content for AUTH-05 Account Activation.
 *
 * "Welcome to Secure Labs" heading, estate-invite body, and a decorative
 * 3-step progress indicator. The stepper is visual-only — step 1 "Account
 * Setup" is always active since this screen IS step 1. Server expansion
 * (GET /auth/activation/:token) is needed to pre-fill the estate name.
 * Figma frame 79:50 hero column.
 */

const STEPS = [{ label: 'Account Setup' }, { label: 'MFA Setup' }, { label: 'All Set!' }] as const;

export function ActivationHero() {
  return (
    <div className="flex flex-col gap-6">
      <div>
        <p className="text-lg font-semibold text-[var(--text-primary)]">Welcome to Secure Labs</p>
        <p className="mt-2 text-base leading-relaxed text-[var(--text-secondary)]">
          You&apos;ve been invited to join an estate.
          <br />
          Let&apos;s get you set up.
        </p>
      </div>

      {/* Decorative 3-step stepper — always at step 1 */}
      <div className="mt-4 flex items-center gap-0">
        {STEPS.map((step, i) => (
          <div key={step.label} className="flex items-center">
            <div className="flex flex-col items-center gap-1.5">
              <div
                className="flex size-7 items-center justify-center rounded-full text-xs font-semibold"
                style={
                  i === 0
                    ? {
                        backgroundColor: 'var(--estate-accent)',
                        color: 'var(--text-inverse)',
                      }
                    : {
                        backgroundColor: 'var(--bg-surface-raised)',
                        color: 'var(--text-tertiary)',
                      }
                }
              >
                {i + 1}
              </div>
              <span
                className="text-[11px] whitespace-nowrap"
                style={{ color: i === 0 ? 'var(--text-accent)' : 'var(--text-tertiary)' }}
              >
                {step.label}
              </span>
            </div>
            {i < STEPS.length - 1 && (
              <div
                className="mx-2 mb-5 h-px w-16"
                style={{ backgroundColor: 'var(--border-default)' }}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
